function minutesToStr(minutes) {
    let broj = +minutes;
    return broj < 10 ? '0' + broj : '' + broj;
}

export default minutesToStr;